import { useCallback } from "react";
export const useSignout = ()=>{
    const postProcessForKakao = useCallback(()=>{
        const searchParams = new URLSearchParams();
        searchParams.set("client_id", process.env.NEXT_PUBLIC_KAKAO_REST_API_KEY);
        searchParams.set("logout_redirect_uri", document.location.origin.concat("/login/kakao-logout"));
        window.open("https://kauth.kakao.com/oauth/logout?".concat(searchParams.toString()), "solvook-kakao-logout", "width=500, height=700, scrollbars=no, resizable=no");
    }, []);
    return {
        postProcessForKakao
    };
};
